/**
 * 地址格式化：国家与一级地址与二级的分隔符用'-'
 * 展示三级级地址
 */
export const formatAddress = (country, province, city) => {
  // 业务规则：展示两级地址
  if (country && (province || city)) {
    // country-province|city
    return `${country}${province ? '-' : ''}${province || ''}${city ? '-' : ''}${city || ''}`
  }

  // 降级
  return `${country || ''} ${province || ''} ${city || ''}`
}

/**
 * 店配地址格式化
 */
export const formatStoreAddress = (stationAddress, stationName, stationCode) => {
  // 如果门店名称和编码都有就显示全部
  return `${stationAddress || ''}${stationAddress ? ',' : ''}${stationName || ''}${stationCode ? '(' : ''}${stationCode || ''}${stationCode ? ')' : ''}`
}
